<template>
  <div class="content-wrap order-info">
    <p class="goods-title">{{ title }}</p>
    <p class="price"><span class="text-l">￥</span>{{ price }}</p>
    <p v-if="!isEnd" class="order-countdown">
      请在
      <span class="minutes">{{ countdown.minutes }}</span>
      <span class="colon">:</span>
      <span class="seconds">{{ countdown.seconds }}</span>
      内支付
    </p>
  </div>
</template>

<script>
export default {
  props: ["timeoutAt", "price", "title", "orderNo"],
  data: function () {
    return {
      countdown: {},
      isEnd: false, //倒计时结束
      timerId: null,
    };
  },
  methods: {
    stopCountdown() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    startCountdown(targetDateString) {
      this.stopCountdown(); // 防止重复启动
      this.timerId = setInterval(() => {
        this.countdown = this.calculateCountdown(targetDateString);
      }, 1000);
    },
    calculateCountdown(dateString) {
      const targetDate = new Date(dateString);
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();
      if (difference <= 0) {
        this.stopCountdown();
        this.isEnd = true;
        // 结束
        window.location.reload();
        return {};
      }

      const totalHours = Math.floor(difference / (1000 * 60 * 60));
      const hours = totalHours % 24;
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      // 如果总小时数超过24小时，直接展示总小时数
      return totalHours >= 24
        ? {
            hours: totalHours < 10 ? "0" + totalHours : totalHours,
            minutes: minutes < 10 ? "0" + minutes : minutes,
            seconds: seconds < 10 ? "0" + seconds : seconds,
          }
        : {
            hours: hours < 10 ? "0" + hours : hours,
            minutes: minutes < 10 ? "0" + minutes : minutes,
            seconds: seconds < 10 ? "0" + seconds : seconds,
          };
    },
  },
  watch: {
    timeoutAt: {
      handler(newVal) {
        if (newVal) {
          this.countdown = this.calculateCountdown(newVal * 1000);
          this.startCountdown(newVal * 1000);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.order-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem 0 2.28rem;

  .text-l {
    font-size: 0.53rem;
  }

  .price {
    font-weight: 600;
    font-size: 1.07rem;
    margin-bottom: 20px;
    color: #0d1400;
    margin-top: 0.4rem;
    margin-bottom: 0.13rem;
  }

  .goods-title {
    font-weight: 400;
    font-size: 0.4rem;
    color: #0d1400;
    line-height: 0.56rem;
    word-break: break-all;
  }

  .order-no {
    color: rgba($primary-color, 0.6);
    margin-bottom: 0.27rem;
  }
}
.order-countdown {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 0.32rem;
  color: #747573;
  line-height: 0.44rem;
  .minutes,
  .seconds {
    width: 0.48rem;
    height: 0.48rem;
    background: #ffeff1;
    border-radius: 0.11rem;
    font-weight: 500;
    font-size: 0.32rem;
    color: #f03349;
    line-height: 0.48rem;
    text-align: center;
    margin: 0 0.12rem;
  }
  .colon {
    font-weight: 500;
    font-size: 0.32rem;
    color: #f03349;
    line-height: 0.48rem;
  }
}
</style>
